import { Button, Text } from '#atoms';
import { useScheduleCoachDetailQuery } from '#hooks/queries/schedules/useScheduleCoachDetailQuery';
import { Modal } from '#molecules';
import { useScheduleManage } from '#providers/SchedulesManage';
import { CSSProperties, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SelecteScheduleBox } from 'src/components/molecules/SelectBox';
import { ModalButtonContainer } from 'src/components/pages/WeeklyCalenderDetail/styles';
import { RoundStatus } from '..';
import * as S from './styles';
import useScheduleMembership from './useScheduleMembership';

interface RoundInfoProps {
  isModify: boolean;
  personId: string;
  selectedLecture: {
    round: number;
    totalRound: number;
    lectureId: string;
  };
  setSelectedLecture: (
    roundInfo: Partial<{ round: number; totalRound: number }>
  ) => void;
  isRoundModify: boolean | undefined;
  roundStatus: RoundStatus | undefined;
  handleTotalRound: (value: string | number) => void;
}
export const RoundInfo = ({
  personId,
  selectedLecture,
  isModify,
  isRoundModify,
  roundStatus
}: RoundInfoProps) => {
  const [searchParams] = useSearchParams();

  const lectureScheduleId = decodeURIComponent(
    searchParams.get('lecture-schedule-id') ?? ''
  );

  const { data: schedule, isLoading } = useScheduleCoachDetailQuery({
    id: lectureScheduleId as string
  });

  // 반복을 수정할 수 없는 경우 모달을 띄움
  const [isOepnModal, setIsOpenModal] = useState(false);

  const textStyles: CSSProperties = {
    width: '80%',
    wordBreak: 'keep-all',
    textAlign: 'center'
  };

  // 수정 모드일 경우 회차 변경이 가능해야함
  // 추가일경우 무조건 회차 변경 가능
  const disabledCondition = isModify ? !isRoundModify : false;

  const { membership } = useScheduleMembership();

  const { setSelectedLecture } = useScheduleManage();

  const totalRoundOptions = membership
    ? Array.from({ length: membership.totalRound }, (_, i) => i + 1)
    : [];

  const roundOptions = membership ? totalRoundOptions : [];

  useEffect(() => {
    if (membership) {
      setSelectedLecture({
        totalRound: membership.totalRound,
        round: membership.completedRoundUntilNow || 0
      });
    }

    if (isModify && schedule) {
      setSelectedLecture({
        totalRound: schedule.totalRound,
        round: schedule.round || 0
      });
    }
  }, [membership]);

  const onVaildTotalRounds = useMemo(() => {
    if (personId && !selectedLecture.totalRound) {
      return '!opacity-60';
    }
    if (selectedLecture.totalRound) {
      return '!opacity-100';
    }
  }, [personId, selectedLecture.totalRound]);

  return (
    <>
      <S.CountBox>
        <Text>회차</Text>
        <S.ButtonBox>
          <div
            onClick={() => {
              if (disabledCondition) {
                setIsOpenModal(true);
                return;
              }
            }}
          >
            <SelecteScheduleBox
              isArrowUse={false}
              value={selectedLecture.round}
              placeholder="진행된 회차"
              options={roundOptions}
              disabled={disabledCondition || !membership}
              displayValue={value => (value === 0 ? '없음' : `${value} 회차`)}
              onClick={value => {
                setSelectedLecture({ round: Number(value) });
              }}
            />
          </div>
          <Text>/</Text>
          <div
            onClick={() => {
              if (disabledCondition) {
                setIsOpenModal(true);
                return;
              }
            }}
          >
            <div
              className={`min-w-[60px] rounded-[6px] p-[10px] flex gap-[5px] bg-[#373245]`}
            >
              <span className={`opacity-20 ${onVaildTotalRounds}`}>
                {`${selectedLecture.totalRound || '총'} 회차`}
              </span>
            </div>
          </div>
        </S.ButtonBox>
      </S.CountBox>

      {roundStatus === 'none' && (
        <S.RoundGuideText roundStatus={roundStatus}>
          총 회차와 현재 회차를 입력하시면 수강권 정보가 자동으로 생성됩니다.
        </S.RoundGuideText>
      )}

      {roundStatus === 'expiration' &&
        selectedLecture.round > selectedLecture.totalRound && (
          <S.RoundGuideText roundStatus={roundStatus}>
            현재 잔여 회차가 없으므로 총 회차를 추가해주세요.
          </S.RoundGuideText>
        )}

      {isOepnModal && (
        <Modal onClose={() => setIsOpenModal(false)}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '24px'
            }}
          >
            <Text style={textStyles}>
              수업에 처음으로 등록된 회차인 경우에만 수정이 가능합니다.
            </Text>
          </div>

          <ModalButtonContainer>
            <Button onClick={() => setIsOpenModal(false)}>확인</Button>
          </ModalButtonContainer>
        </Modal>
      )}
    </>
  );
};
